"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var EditCalendar = function EditCalendar(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M1.53863 13.3334C1.20187 13.3334 0.916829 13.2167 0.683496 12.9834C0.450163 12.7501 0.333496 12.465 0.333496 12.1283V3.20523C0.333496 2.86847 0.450163 2.58343 0.683496 2.35009C0.916829 2.11676 1.20187 2.00009 1.53863 2.00009H2.46171V0.589844H3.48733V2.00009H8.5386V0.589844H9.53858V2.00009H10.4617C10.7984 2.00009 11.0835 2.11676 11.3168 2.35009C11.5501 2.58343 11.6668 2.86847 11.6668 3.20523V6.53856H10.6668V5.87189H1.33348V12.1283C1.33348 12.1795 1.35485 12.2266 1.39758 12.2693C1.44032 12.312 1.48734 12.3334 1.53863 12.3334H5.94886V13.3334H1.53863ZM1.33348 4.87191H10.6668V3.20523C10.6668 3.15394 10.6454 3.10692 10.6027 3.06418C10.56 3.02144 10.513 3.00008 10.4617 3.00008H1.53863C1.48734 3.00008 1.44032 3.02144 1.39758 3.06418C1.35485 3.10692 1.33348 3.15394 1.33348 3.20523V4.87191ZM7.41041 13.3334V11.5719L11.0296 7.96931C11.1125 7.88641 11.2023 7.82808 11.2989 7.79431C11.3954 7.76055 11.492 7.74368 11.5886 7.74368C11.692 7.74368 11.7931 7.76333 11.8918 7.80264C11.9905 7.84197 12.0792 7.90094 12.1578 7.97956L12.7745 8.60264C12.8463 8.68554 12.9018 8.77528 12.9411 8.87186C12.9805 8.96845 13.0001 9.06503 13.0001 9.16161C13.0001 9.25819 12.9822 9.35648 12.9463 9.45648C12.9104 9.55648 12.8531 9.64793 12.7745 9.73083L9.17193 13.3334H7.41041ZM8.20526 12.5385H8.8386L11.0027 10.3642L10.6963 10.0475L10.386 9.73468L8.20526 11.9052V12.5385ZM10.6963 10.0475L10.386 9.73468L11.0027 10.3642L10.6963 10.0475Z",
    fill: "#4B4FA6"
  }, colorStyles)));
};

EditCalendar.propTypes = _inline_svg2.default.propTypes;
EditCalendar.defaultProps = _inline_svg2.default.defaultProps;
var _default = EditCalendar;
exports.default = _default;